import {
    Component, Input, OnInit, ViewChild,
    ViewContainerRef, ComponentFactoryResolver
} from "@angular/core";

import { Observable } from 'rxjs';

import {
    Investor, InvestorMonthlyCut, InvestorMonthlyCutProviders
} from '../../../../../../_models';
import { MonthlyCut } from '../../../../../../_models/Classes';
import { ModalComponent } from '../../../../../../shared/modal';
import { DropFileComponent } from '../../../../../../shared/drop-file';
import { AlertService, AlertComponent } from '../../../../../../shared/alert';

export class InvoiceOption {
    id: number;
    text: string;
    constructor(json?: any) {
        if (json) Object.assign(this, json);
    }
    toString(): string {
        return this.text;
    }
}

@Component({
    selector: 'app-investors-monthly-cut',
    templateUrl: './investors-monthly-cut.component.html',
    styleUrls: ['./investors-monthly-cut.component.scss'],
    providers: [InvestorMonthlyCutProviders]
})

export class InvestorsMonthlyCutComponent implements OnInit {
    investorTexts = {
        label: "Propietario",
        notFound: "Propietario no encontrado",
        loading: "Cargando propietarios...",
        none: "Ningun propietario"
    };
    additionalEntry = 'Todos';
    @Input() monthlyCut: MonthlyCut;
    @ViewChild(ModalComponent) modal: ModalComponent;
    @ViewChild('xml') xml: DropFileComponent;
    @ViewChild('pdf') pdf: DropFileComponent;
    title: string;
    invoiceFiles: [File, File] = [null, null];
    invoiceOptions = [
        new InvoiceOption({ id: 1, text: 'Todas' }),
        new InvoiceOption({ id: 2, text: 'Si' }),
        new InvoiceOption({ id: 3, text: 'No' }),
    ];
    uploadInvoiceReq$: Observable<any>;
    searchReq$: Observable<any>;
    investorSearchParam: string;
    invoiceOptionParam: string;
    authorized: boolean;
    @ViewChild('alert',
        { read: ViewContainerRef }) private alertRef: ViewContainerRef;
    params: string = 'include=investor,invoice';
    constructor(
        private investorData: Investor,
        private data: InvestorMonthlyCut,
        private _cfr: ComponentFactoryResolver,
        private _alertService: AlertService
    ) { }
    ngOnInit() {
        this.getData();
    }

    investorFilterChange(investor) {
        if (investor == this.additionalEntry) { // Todos
            this.investorSearchParam = ``;
        }
        else {
            this.investorSearchParam = `iid=${investor.id}`;
        }
        this.makeSearchReq();
    }
    filterInvoiceChange(invoiceOption) {
        if (invoiceOption.id == 2) { // Si
            this.invoiceOptionParam = `hinvoice=1`;
        }
        else if (invoiceOption.id == 3) { // No
            this.invoiceOptionParam = `hinvoice=0`;
        }
        else { // Todas
            this.invoiceOptionParam = ``;
        }
        this.makeSearchReq();
    }
    makeSearchReq() {
        let urlParams = `${this.params}`;
        if (this.investorSearchParam) urlParams = `${urlParams}&${this.investorSearchParam}`;
        if (this.invoiceOptionParam) urlParams = `${urlParams}&${this.invoiceOptionParam}`;
        this.searchReq$ = this.data.getAll(this.monthlyCut.id, urlParams);
    }
    performSearch() {
        this.searchReq$.subscribe(data => { });
    }
    askForFileToUpload(investorMonthlyCut) {
        this.data.instance = investorMonthlyCut;
        this.title =
            (investorMonthlyCut.investor) ? `Factura de ${investorMonthlyCut.investor.name}` : `Factura`;
        this.xml.fileBuffer = [];
        this.pdf.fileBuffer = [];
        this.modal.show();
    }
    getXmlInvoice(invoice) {
        this.invoiceFiles[0] = invoice;
        this.uploadInvoiceReq$ = this.data.uploadInvoice(this.invoiceFiles);
    }
    getPdfInvoice(invoice) {
        this.invoiceFiles[1] = invoice;
        this.uploadInvoiceReq$ = this.data.uploadInvoice(this.invoiceFiles);
    }
    end() {
        this.getData();
        this.close();
    }
    close() {
        this.modal.hide();
    }
    private showAlert(target) {
        this[target].clear();
        let factory = this._cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
    alertD(message, type: 'error' | 'success' | 'warning' = 'error') {
        this.showAlert('alertRef');
        this._alertService[type](message);
    }
    ceil(data: number) {
        return Math.ceil(data);
    }
    getData() {
        this.authorized =
            (this.monthlyCut.authorization) ? this.monthlyCut.authorization.state == 'authorized' : false;
        this.data.getAll(this.monthlyCut.id, this.params).subscribe(monthlyCuts => { });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-detail/investors-monthly-cut/investors-monthly-cut.component.ts